import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { PdvService } from '@app/services/pdv/pdv.service';

@Component({
    selector: 'product-menu',
    templateUrl: 'product-menu.component.html',
    styleUrls: ['product-menu.component.scss'],
    providers : [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ProductMenuComponent),
            multi: true
        }
    ]
})
export class ProductMenuComponent {
    check: any;
    @Input()
    elementTime
    @Input()
    product;
    loadAvatar = false;
    @Output()
    OnAdd:EventEmitter<boolean>=new EventEmitter<boolean>(); 
    @Output()   
    OnPersonalize:EventEmitter<boolean>=new EventEmitter<boolean>();  
    @Input()
    value:number;
    @Input()
    name:string;
    siteClose = false;
    subscriptions2: Subscription[] = [];
    _onChange = (_: any) => { };
    _onTouched = () => { };

    writeValue(value: any): void {
        this.check = value;
        this._onChange(value);
    }

    registerOnChange(fn: (_: any) => {}): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: () => {}): void {
        this._onTouched = fn;
    }

    /**
     * Utility method to get values from
     * selected items
     * @returns {boolean}
     */
    private getValues(): boolean {
        return this.check;
    }

    change(){
        this.writeValue(this.getValues());
    }
    constructor(
        private pdvService:PdvService
    ){
    }
    ngOnInit(){
        let sub=this.pdvService.pdv.subscribe(
            (data)=>{
                this.siteClose=data.closeSite;
            }
        )
        this.subscriptions2.push(sub);
    }
    addToBasket(){
        this.OnAdd.emit(true);
    }

    personalize(){
        this.OnPersonalize.emit(true);
    }
    unsubscribe2() {
        this.subscriptions2.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions2 = [];
    }
    ngOnDestroy() {
        this.unsubscribe2();
    }

   
}
